import { useMutation } from "@tanstack/react-query";
import { FeedbackResponse } from "api/schema/insights/threads";
import { AxiosError } from "axios";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";

interface SubmitFeedbackParams {
  companyId: string;
  threadId: string;
  messageId: string;
  feedbackScore: number;
}

export const useSubmitMessageFeedback = () => {
  const publicApi = usePublicApiService();

  return useMutation<FeedbackResponse, AxiosError, SubmitFeedbackParams>({
    mutationFn: ({ companyId, threadId, messageId, feedbackScore }) =>
      publicApi.submitMessageFeedback(
        { companyId, threadId, messageId },
        { feedbackScore }
      ),
  });
};
